<template>
  <div>
    <Loader v-if="loader.data" />
    <div class="container-fluid px-0" v-cloak>
      <div class="d-flex">
        
     
        <div class="page__content">
          <Nav
            @show-contrast-view="toggleShowContrast"
            @show-regular-font-view="toggleRegularFontView"
            @show-middle-font-view="toggleMiddleFontView"
            @show-big-font-view="toggleBigFontView"
          />
          <div
            v-show="openModalInvitation"
            class="back back--invitationDesktop"
            @click="toggleModalInvitation(false)"
          >
            <span class="d-none d-lg-block">Powrót do strony</span>
             <span class="d-block d-lg-none">X</span>
          </div>
          <Content />
        </div>
        <Form />
      </div>
    </div>
  </div>
</template>

<script>
import Content from "./Content.vue";
import Nav from "./elements/Nav.vue";
import Form from "./Form.vue";
import Loader from "./elements/Loader.vue";

export default {
  name: "Page",

  data() {
    return {
      formAmountValue: 35,
      openModalInvitation: false,
      openModalPayment: false,
      contrastView: false,
      fontRegularView: true,
      fontMiddleView: false,
      fontBigView: false,
      mainPage: true,
      showAnimationFooter: false,
      showAnimationOther: false,
    };
  },
  created() {
    this.$root.$on("formAmountDown", () => {
      this.formAmountDown();
    });
    this.$root.$on("formAmountUp", () => {
      this.formAmountUp();
    });
    this.$root.$on("setFormAmountValue", (e) => {
      this.setFormAmountValue(e);
    });
    this.$root.$on("toggleModalInvitation", (e) => {
      this.toggleModalInvitation(e);
    });
    this.$root.$on("toggleModalPayment", (e) => {
      this.toggleModalPayment(e);
    });
  },
  provide() {
    const appData = {
      formAmountValue: this.formAmountValue,
      openModalInvitation: this.openModalInvitation,
      openModalPayment: this.openModalPayment,
    };

    Object.defineProperty(appData, "formAmountValue", {
      enumerable: true,
      get: () => this.formAmountValue,
    });
    Object.defineProperty(appData, "openModalInvitation", {
      get: () => this.openModalInvitation,
    });
    Object.defineProperty(appData, "openModalPayment", {
      get: () => this.openModalPayment,
    });

    return {
      updateCheckoutInfo: this.updateCheckoutInfo,
      appData,
    };
  },
  components: {
    Loader,
    Content,
    Nav,
    Form,
  },
      inject: ["loader"],
  methods: {
    formAmountUp() {
      if (this.formAmountValue < 4998) {
        this.formAmountValue = this.formAmountValue + 1;
      } else {
        this.formAmountValue = 4999;
      }
    },
    formAmountDown() {
      if (this.formAmountValue > 35) {
        this.formAmountValue = this.formAmountValue - 1;
      } else {
        this.formAmountValue = 35;
      }
    },
    setFormAmountValue(val) {
      this.formAmountValue = parseInt(val, 10);
    },
    toggleModalInvitation(val) {

      this.openModalInvitation = val;
    },
    toggleModalPayment(val) {
      this.openModalPayment = val;
    },
    toggleShowContrast: function () {
      this.contrastView = !this.contrastView;
    },
    toggleRegularFontView: function () {
      this.fontRegularView = !this.fontRegularView;
    },
    toggleMiddleFontView: function () {
      this.fontMiddleView = !this.fontMiddleView;
    },
    toggleBigFontView: function () {
      this.fontBigView = !this.fontBigView;
    },
  },

  watch: {
    contrastView: function () {
      const el = document.body;
      if (this.contrastView) {
        el.classList.add("body--contrast");
      } else {
        el.classList.remove("body--contrast");
      }
    },

    fontRegularView: function () {
      const el = document.getElementsByTagName("html")[0];
      el.classList.remove("body--middle-font");
      el.classList.remove("body--big-font");
    },
    fontMiddleView: function () {
      const el = document.getElementsByTagName("html")[0];

      el.classList.add("body--middle-font");
      el.classList.remove("body--big-font");
    },
    fontBigView: function () {
      const el = document.getElementsByTagName("html")[0];

      el.classList.remove("body--middle-font");
      el.classList.add("body--big-font");
    },
  },
};
</script>
